<template>
	<div id="content">
		<div class="wrapper">
			<h1 class="large">1999 - 2019</h1>
			<p>
				CARMARKT hat Geburtstag, und das an unserem neuen Standort direkt an der A40 in Mülheim.<br />
				Somit sind wir für neue und treue Kunden aus Mülheim und auch Essen bestens erreichbar.
			</p>
			<h2>So finden Sie zu uns</h2>
			<p>Von der A40 Ausfahrt "Mülheim Styrum" aus Richtung Mülheim, befindet sich CARMARKT nach 50 Metern auf der rechten Straßenseite (gegenüber der Willy-Brand-Schule).</p>
			<p><router-link to="/location" class="btn">Auf der Karte anzeigen</router-link></p>
			<h2>Alte Werte - neue Werkstatt</h2>
			<p>
				Nach 15 Jahren in Mülheim Heißen und dem vorrübergehenden Standort in Essen-Rüttenscheid kommt mit CARMARKT nach Opel Einig wieder ein traditionsreicher Betrieb nach Mülheim.
			</p>
			<p>
				Mark Purushotham ist KFZ-Mechaniker und staatlich geprüfter KFZ-Techniker mit langjähriger Berufserfahrung bei Fiat, TÜV-Rheinland und 20 Jahren Selbständigkeit, leidenschaftlicher Schrauber mit Liebe zu Oldtimern.
			</p>
			<p><router-link to="/services" class="btn">Unsere Leistungen</router-link></p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'About'
}
</script>

<style lang="scss" scoped>
h1.large {
	font-size: 32pt;
}
</style>
